import * as React from "react";

import type {Permission} from "./permission-types.ts";
import type {PermissionProviderResultProps} from "./types.ts";

/**
 * PermissionProviderContextPayload
 *
 * This type describes the payload of the PermissionProviderContext.
 */
export interface PermissionProviderContextPayload {
    /**
     * Override permission query result for a given permission and scope.
     *
     * @returns {?PermissionProviderResultProps} - `null` if the permission should be queried from
     * the server, otherwise a fixed result state.
     */
    readonly hasPermission: (
        permission: Permission,
    ) => PermissionProviderResultProps | null | undefined;
}

/**
 * PermissionProviderContext
 *
 * This React Context object can be used to override permissions checks for
 * the PermissionProvider. This is useful both in unit tests and in
 * stories.
 *
 * When `null` or the context function returns `null`, the query will be
 * invoked.
 */
export const PermissionProviderContext = React.createContext<
    PermissionProviderContextPayload | null | undefined
>(null);
PermissionProviderContext.displayName = "PermissionProviderContext";
